window.addEventListener("DOMContentLoaded", function () {
  // ===== Open Form =====
  window.openForm = function (jobId, jobTitle) {
    const modal = document.getElementById("applyModal");
    const jobTitleEl = document.getElementById("jobTitle");
    const hiddenJobInput = document.getElementById("hiddenJobTitle");

    // Set job details
    jobTitleEl.innerText = jobTitle;
    hiddenJobInput.value = jobTitle;

    // Show modal (overlay)
    modal.classList.remove("hidden");
    modal.classList.add("flex");

    // Disable page scroll while modal open
    document.body.style.overflow = "hidden";
  };

  // ===== Close Form =====
  window.closeForm = function () {
    const modal = document.getElementById("applyModal");

    // Hide modal
    modal.classList.remove("flex");
    modal.classList.add("hidden");

    // Re-enable page scroll
    document.body.style.overflow = "auto";
  };

  // ===== Optional: Close on background click =====
  const modal = document.getElementById("applyModal");
  if (modal) {
    modal.addEventListener("click", function (e) {
      if (e.target === modal) {
        closeForm();
      }
    });
  }

  // ===== Optional: Handle form submit =====
  const form = document.getElementById("applyForm");
  if (form) {
    form.addEventListener("submit", function (e) {
      e.preventDefault();

      // You can connect this to EmailJS, Zapier, or Shopify Form Handler later
      alert("✅ Your application has been submitted successfully!");

      // Reset form + close modal
      form.reset();
      closeForm();
    });
  }
});
